import StoredAnalysis from 'domain/entity/storedAnalysis';
import { Result } from 'domain/types';
import DuplicateStoredAnalysisClient from 'use-case/storedAnalysis/duplicate/duplicateStoredAnalysisClient';

import DuplicateStoredAnalysisCriteria from 'use-case/storedAnalysis/duplicate/duplicateStoredAnalysisCriteria';

export type DuplicateStoredAnalysisResult = Result<StoredAnalysis>;
export type DuplicateStoredAnalysis = (criteria: DuplicateStoredAnalysisCriteria) => Promise<DuplicateStoredAnalysisResult>;

export default (duplicateAnalysisClient: DuplicateStoredAnalysisClient): DuplicateStoredAnalysis => (
    criteria: DuplicateStoredAnalysisCriteria
): Promise<DuplicateStoredAnalysisResult> => duplicateAnalysisClient(criteria);
